import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute }             from '@angular/router';

import { SubscriptionsService }       from './subscriptions.service';

@Component({
  selector: 'app-subscription-history',
  templateUrl: './subscription-history.component.html',
  styleUrls: ['./subscription-history.component.less']
})
export class SubscriptionHistoryComponent implements OnInit {
  public history: any[] = null;
  public form: FormGroup;
  public saving: boolean;
  private _subscriptionId: number;

  constructor(private api: SubscriptionsService, private route: ActivatedRoute, private _fb: FormBuilder) {
    this.route.parent.params.subscribe(params => {
      this._subscriptionId = params['id'];
      this.loadHistory();
    });
  }

  ngOnInit() {
    this.form = this._fb.group({
      description: ['']
    });
  }

  save(data: any) {
    if (this.saving) {
      return;
    }
    if (!data.description.trim()) {
      alert("Please enter a description");
      return;
    }
    this.saving = true;
    this.api.addHistoryNote(this._subscriptionId, data.description).subscribe(() => {
      this.form.controls['description'].setValue('');
      this.saving = false;
      this.loadHistory();
    }, err => {
      alert("Unable to save note");
      this.saving = false;
    });
  }

  private loadHistory() {
      this.api.getSubscriptionHistory(this._subscriptionId).subscribe(history => this.history = history);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-history.component.ts